/**
 * SignUpCtaCard Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { createFragmentContainer } from 'react-relay';
import { VelocityComponent } from 'velocity-react';

import ImageLoaded from '../../../../containers/ImageLoaded';

import { pushPostAuthenticationRequestPage } from '../../../../redux/actions/postAuthenticationRequests';
import { toggleSignUpFormVisibility } from '../../../../redux/actions/ui';
import { createHref } from '../../../../utils/router';

import { SignUpCtaFragment } from '../../../../relay/signUpCta';
import Button from '../../../atoms/buttons/Button';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import './styles.scss';

// tslint:disable-next-line:no-empty-interface
interface IOwnProps {
  viewer?: GQL.IViewer;
}

interface IOwnStateProps extends IOwnProps {
  currentLocation: IRouterLocation;
  isUserLoggedIn: boolean;
}

interface IOwnMergedProps {
  showSignUpForm(): void;
}

type SignUpCtaCardProps = IOwnStateProps & IOwnMergedProps;

const classes = new BEM('sign-up-cta-card');

class SignUpCtaCardInternal extends React.PureComponent<SignUpCtaCardProps, IOwnStateProps> {

  render() {
    const { viewer } = this.props;
    const images = viewer!.home_page!.sign_up_cta_images!;
    const randomImage = images[Math.floor(Math.random() * images.length)];
    return (
      <ImageLoaded>
        {({ imageLoaded }) => (
          <div
            {...classes('', { loading: !imageLoaded, ready: imageLoaded })}
          >
            <div
              {...classes('image') }
            >
              <VelocityComponent animation={imageLoaded ? 'fadeIn' : 'fadeOut'}>
                <img src={randomImage} />
              </VelocityComponent>
            </div>
            <div {...classes('content')}>
              <Heading
                is="h4"
                {...classes('title') }
              >
                <b>Download Music</b><br />
                <b>Create &amp; Share</b> Playlists<br />
                Get our <b>Staff Picks</b>
              </Heading>
              <Button
                label="Create your account"
                colorScheme="dark"
                onClick={() => this.props.showSignUpForm()}
                {...classes('sign-up-button') }
              />
              <br />
              <Span size="small">No credit card required.</Span>
            </div>
          </div>
        )}
      </ImageLoaded>
    );
  }
}

const Connected = connect<IOwnStateProps, IDispatchProps, IOwnProps, SignUpCtaCardProps, IStoreState>(
  ({ found, user }, props) => ({
    ...props,
    currentLocation: found.match.location,
    isUserLoggedIn: user.isLoggedIn,
  }),
  (dispatch) => ({ dispatch }),
  (stateProps, { dispatch }) => ({
    ...stateProps,
    showSignUpForm: () => {
      dispatch(pushPostAuthenticationRequestPage({ page: createHref(stateProps.currentLocation) }));
      dispatch(toggleSignUpFormVisibility(true));
    },
  }),
)(SignUpCtaCardInternal);

export const SignUpCtaCard = createFragmentContainer(
  Connected,
  SignUpCtaFragment,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/media/SignUpCtaCard/index.tsx